"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConsumerTrackingServiceV1 = void 0;
/**
 * Implementation of the tracking service interface via delegation to the {@link GlobalTrackingServiceV1}.
 */
class ConsumerTrackingServiceV1 {
    constructor(delegate, defaultId) {
        this.delegate = delegate;
        this.featureAppId = defaultId;
    }
    track(data) {
        this.delegate.track(data, this.featureAppId, this.featureAppName);
    }
    updateComponent(data) {
        this.delegate.updateComponent(data, this.featureAppId);
    }
    getDatalayer() {
        return this.delegate.getDatalayer();
    }
}
exports.ConsumerTrackingServiceV1 = ConsumerTrackingServiceV1;
//# sourceMappingURL=ConsumerTrackingService.js.map